import React, { useEffect, useState } from 'react';
import TournamentPlanningCanvas from '../../components/canvas/TournamentFormulaCanvas';
import FormulaCanvasRF from '../../components/canvas-rf/FormulaCanvasRF';
import API from '../../api/API';

// Strangler: il canvas React Flow è attivabile con ?canvas=rf oppure
// localStorage.formulaCanvas === 'rf'. Default: canvas storico.
// (Non è un hook React: legge solo URL/localStorage.)
const isReactFlowCanvasEnabled = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get('canvas') === 'rf' || localStorage.getItem('formulaCanvas') === 'rf';
};

const AFormula = () => {
  const useRF = isReactFlowCanvasEnabled();
  const [torneoStato, setTorneoStato] = useState(null);

  // la formula si modifica solo a torneo in preparazione (il server rifiuta comunque con 409)
  useEffect(() => {
    try {
      const stored = localStorage.getItem('selectedEdition');
      const idEdizione = stored ? JSON.parse(stored).id : null;
      if (idEdizione) {
        API.torneo.dettaglio(idEdizione).then((r) => {
          if (r.isSuccess && r.data) setTorneoStato(r.data.stato);
        });
      }
    } catch {
      // localStorage corrotto: nessun banner
    }
  }, []);

  const formulaBloccata = torneoStato != null && torneoStato !== 'preparazione';

  return (
    <div style={{ height: '100vh', overflow: 'hidden', margin: 0, padding: 0 }}>
      {formulaBloccata && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '10px 16px',
            background: '#fef5e7',
            color: '#b9770e',
            borderBottom: '1px solid #f5cba7',
            fontWeight: 600,
          }}
        >
          <i className="fas fa-lock"></i>
          {torneoStato === 'inCorso' ? 'Torneo avviato' : 'Torneo chiuso'}: la formula non è più
          modificabile (i salvataggi verranno rifiutati).
        </div>
      )}
      {/* a torneo chiuso il canvas è in sola visualizzazione (niente bottoni di aggiunta/salvataggio) */}
      {useRF
        ? <FormulaCanvasRF readOnly={torneoStato === 'chiuso'} />
        : <TournamentPlanningCanvas readOnly={torneoStato === 'chiuso'} />}
    </div>
  );
};

export default AFormula;
